import { consumeContext } from "@/lib/consume/context"
import { ServicesContext } from "@/lib/services/context"

export const consumeServices = consumeContext({
  Context: ServicesContext,
  provideTo: `services`,
})
